import EmailSenderLayout from "../EmailSenderLayout";
import { NSARouterMakerProps, NSAVerificationPage } from "namirasoft-account-react";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";
import { useParams } from "react-router-dom";
import { NSBoxEmail } from "namirasoft-site-react";
import { useRef } from "react";

export interface IVerifyEmailPage extends NSARouterMakerProps, EmailSenderRouterProps { }

function VerifyEmailPage(props: IVerifyEmailPage)
{
	let NSBoxEmail_Email = useRef<NSBoxEmail>(null);

	let { provider_id } = useParams();

	return (
		<EmailSenderLayout {...props}
			action={{
				title: "Verify Email",
				description: "Enter the verification code sent to your email address to confirm your request and activate the service.",
				menus: {}
			}}
		>
			<NSAVerificationPage
				{...props}
				contact_type={"Email"}
				contact_value_name={"Email"}
				getContactValue={(checkErrors: boolean) =>
				{
					return NSBoxEmail_Email.current?.getValue(checkErrors) ?? "";
				}}
				onRequest={async email =>
				{
					if (provider_id)
						await props.servers.email_sender.provider.Request(provider_id, { email });
				}}
				onVerify={async code =>
				{
					if (provider_id)
						await props.servers.email_sender.provider.Verify(provider_id, { code });
				}}
				onFinished={() =>
				{
					props.url.redirect("/", {});
				}}
			>
				<NSBoxEmail
					ref={NSBoxEmail_Email}
					title="Email"
					required
				/>
			</NSAVerificationPage>
		</EmailSenderLayout>
	);
}

export default VerifyEmailPage;